import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import DisablePluginCommand from './disableplugincommand';

export default class disablePluginEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add( 'disablePlugin', new DisablePluginCommand( editor ) );

  }
}